import React from "react";
// import { MdTrendingFlat } from "react-icons/md";
import Button from "../button";
import {
  GradiationWrap,
  Line,
  NumberWrap,
  ContentWrap,
  Heading,
  Text
} from "./gradiation.style";
import Icon from "../../../components/ui/icon";

const Gradiation = ({ number, title, desc, path, ...restProps }) => {
  const { btnStyle, isLast } = restProps;

  // Inline style fallbacks for styled-components hydration issues in dev mode
  const wrapperStyle = { position: 'relative', padding: '0 15px' };
  const lineStyle = {
    width: '100%',
    height: '1px',
    background: '#ededed',
    position: 'absolute',
    top: '24px',
    left: '15px',
    display: isLast ? 'none' : 'block'
  };
  const numberWrapStyle = { display: 'inline-block', position: 'relative', marginBottom: '56px' };
  const numberStyle = {
    position: 'relative',
    zIndex: 1,
    width: '48px',
    height: '48px',
    lineHeight: '44px',
    textAlign: 'center',
    border: '2px solid #e8e8e8',
    borderRadius: '50%',
    fontSize: '18px',
    backgroundColor: '#fff',
    marginBottom: 0,
    display: 'block'
  };

  return (
    <GradiationWrap {...restProps} style={wrapperStyle}>
      <Line style={lineStyle} />
      <NumberWrap style={numberWrapStyle}>
        <div className="mask">
          <div className="wave-pulse wave-pulse-1"></div>
          <div className="wave-pulse wave-pulse-2"></div>
          <div className="wave-pulse wave-pulse-3"></div>
        </div>
        {number && <h6 className="number" style={numberStyle}>{number}</h6>}
      </NumberWrap>
      <ContentWrap>
        {title && <Heading style={{ fontWeight: 500 }}>{title}</Heading>}
        {desc && <Text style={{ marginTop: '17px', marginBottom: '20px' }}>{desc}</Text>}
        {path && (
          <Button
            {...btnStyle}
            to={path}
            iconname="far fa-long-arrow-right"
          >
            Look More
          </Button>
        )}
      </ContentWrap>
    </GradiationWrap>
  );
};

Gradiation.defaultProps = {
  btnStyle: {
    varient: "texted",
    color: "primary",
    fontSize: "14px"
  }
};

export default Gradiation;
